import clsx from 'clsx'
import ModalExport from 'components/commons/modal-export'

export const AnalyticVoting = ({
    options,
    activeTab,
    onChangeTab,
    content,
    modal,
    setModal,
    onExport,
    isExporting,
    totalResult,
}) => {
    return (
        <div className='flex flex-col gap-6 px-9 py-4'>
            <div className='flex overflow-auto'>
                {options?.map((item, index) => (
                    <div
                        key={index}
                        className={clsx(
                            'font-bold capitalize text-[#2B2B2B] cursor-pointer px-4 py-2',
                            activeTab === item && 'bg-[#F2F7FF] border-b border-[#3C6CD6]',
                        )}
                        onClick={() => onChangeTab(item)}
                    >
                        {item}
                    </div>
                ))}
            </div>
            {content}

            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setModal({ ...modal, export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={totalResult}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
        </div>
    )
}
